import React from "react";
import { withRouter } from "react-router-dom";
import withSSR from "../components/withSSR";

import { Formik, Form } from "formik";
import { LoginSchema } from "../forms/schema";
import { IconTextInput } from "../forms/components";

import { doLogin } from "../libs/functions";

import Swal from "sweetalert2";
import logo from "../assets/img/logo.png";

class Login extends React.Component {
  handleSubmit = (values, { setSubmitting, resetForm }) => {
    Swal.fire({
      title: "Logging In...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      onOpen: async () => {
        try {
          let status = await doLogin(values.username, values.password);
          setSubmitting(false);
          if (status) {
            window.location = "/merchants";
          } else {
            Swal.fire({
              icon: "error",
              title: "Unauthorised",
            }).then(() => {
              resetForm();
            });
          }
        } catch (err) {
          console.log(err);
          setSubmitting(false);
          Swal.fire({
            icon: "error",
            title: "Unauthorised",
          }).then(() => {
            resetForm();
          });
        }
      },
    });
  };

  render() {
    return (
      <div className="Login">
        <div className="uk-card uk-card-default uk-width-1-3@m">
          <div className="uk-card-body">
            <div className="uk-flex uk-flex-column uk-flex-middle">
              <img className="uk-img" src={logo} width="100" />
              <h3 className="uk-card-title uk-text-bold uk-margin-top">
                T05 Pay Partner Portal
              </h3>
            </div>
            <Formik
              initialValues={LoginSchema.initialValues}
              validationSchema={LoginSchema.validation}
              onSubmit={this.handleSubmit}
            >
              <Form className="uk-form-stacked login-form">
                <IconTextInput
                  icon="user"
                  name="username"
                  type="text"
                  placeholder="Username"
                />
                <IconTextInput
                  icon="lock"
                  name="password"
                  type="password"
                  placeholder="Password"
                />
                <div className="uk-margin">
                  <button
                    type="submit"
                    className="uk-button uk-button-primary uk-width-1-1"
                  >
                    Login
                  </button>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      </div>
    );
  }
}

export default withSSR(withRouter(Login));
